import { Platform } from 'react-native'

import { IS_PRODUCTION } from '../common/constants/constants'
import { shouldDisableCostlyVendors } from '../flags/utils'

export const BRAZE_SDK_URL = 'sdk.iad-02.braze.com'

export const BRAZE_SDK_KEY =
  Platform.select({
    android: IS_PRODUCTION ? process.env.ANDROID_BRAZE_KEY : process.env.ANDROID_BRAZE_KEY_STAGING,
    ios: IS_PRODUCTION ? process.env.IOS_BRAZE_KEY : process.env.IOS_BRAZE_KEY_STAGING,
    default: process.env.BRAZE_SDK_KEY,
  }) ?? ''

export interface BrazeContextValue {
  isReady: boolean
  logCustomEvent: (event: string, properties?: Record<string, any>) => void
}

export const BRAZE_NOOP: BrazeContextValue = { isReady: false, logCustomEvent: () => {} }

export type UseBrazeSDK = (isBrazeEnabled: boolean, hashedLyraId?: string | null) => BrazeContextValue

export const shouldInitializeBraze = (enabled: boolean): boolean => {
  if (!enabled) {
    return false
  }
  if (!BRAZE_SDK_KEY) {
    console.error('[Braze] BRAZE_SDK_KEY is not configured. SDK will not be initialized.')
    return false
  }
  if (shouldDisableCostlyVendors) {
    return false
  }
  if (typeof window !== 'undefined' && window.Cypress) {
    return false
  }
  return true
}
